import { Flex, Input, Span, Button, Label, Grid } from '@fareye/ui'
import { getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { formatters } from '../config/constants'
import { ColFullHeight } from '../style/styled'
import { IColumn } from '../utility/types'

function generateColumnObject(column: IColumn, propsConfig: any) {
  //TODO: Add Tracking column
  let { label, key, formatter } = column

  const { t, setSelectedDevice, setDevices } = propsConfig
  switch (key) {
    case 'action':
      return {
        Header: <Label color="black">{t(label)}</Label>,
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="referenceNo|slug">
            <Grid gridTemplateColumns="repeat(3,1fr)" gridGap={'5px'}>
              <Button
                onClick={() =>
                  setSelectedDevice({
                    data: original,
                    openHistoryModal: true,
                    openEditModal: false
                  })
                }
                variant="s secondary"
              >
                History
              </Button>
            </Grid>
          </ColFullHeight>
        )
      }

    default:
      return {
        Header: <Label color="black">{t(label)}</Label>,
        id: key,
        width: 50,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
            if (typeof value === 'boolean') {
                if (key === 'tripStatus') {
                  value = value ? 'Active' : 'Inactive'
                } else {
                  value = value ? 'True' : 'False'
                }
            }
            const statusMap: any = {
                mapped: 'Mapped',
                unmapped: 'UnMapped'
                }

                if (key === 'status' && value) {
                value = statusMap[value.toLowerCase()] || value
            }
          return (
            <ColFullHeight data-testid={key}>
              <Span fontSize={14} variant="ellipsis">
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumn[],
  propsConfig?: any
) {
  const COLUMNS = reqdColumns.map(ele => generateColumnObject(ele, propsConfig))
  return COLUMNS
}
